import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
};
function t(d, e) {
  return n(), l("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m14 21.499-7.828 4.154 1.495-8.799-6.334-6.231 8.753-1.284L14 1.333l3.914 8.006 8.753 1.284-6.334 6.231 1.495 8.8z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: t };
export {
  c as default,
  t as render
};
